import I18n from 'APP/I18n'

import type { BookingWindow } from '../AppointmentBookingBase/types'

export const getBookingWindowText = ({ dateFrom, dateUntil }: BookingWindow) =>
  I18n.t('AppointmentBooking.recommended_date_range', {
    dateFrom: dateFrom.format(I18n.t('AppointmentBooking.date_range_from_format')),
    dateUntil: dateUntil.format(I18n.t('AppointmentBooking.date_range_until_format')),
  })
